(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["youtube-section"] && !Shopify.designMode) return;
  try {
    

const videosContainer = document.querySelector('#yt-videos');
let movies = [];

async function getMovieList() {
  const URL = "https://youtube.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=3&playlistId=PL147ro3n_L3liXqUouuQDZsc6S0Ud84ym&key=AIzaSyDYYOFgJQJZMo8udOzr8-P2i-lAU-hTX6A";
  try {
    const response = await fetch(URL);
    const moviesData = await response.json();
    movies = moviesData.items.map(movie => {
        return {
            id: movie.snippet.resourceId.videoId,
            title: movie.snippet.title,
            date: changeDateFormat(movie.snippet.publishedAt),
        }
    });
  } catch (err) {
    console.error(err);
  }
  renderVideos(movies);
}

function createVideoEl( videoId, videoTitle, videoDate ) {
    const ytMovieContainer = document.createElement('div');
    ytMovieContainer.classList.add('yt-video');

    const ytMovie = document.createElement('lite-youtube');
    ytMovie.setAttribute('videoid', videoId)
    ytMovie.classList.add('yt-video__video');
    ytMovieContainer.appendChild(ytMovie)
    
    const ytVideoDate = document.createElement('span');
    ytVideoDate.classList.add('yt-video__date');
    ytVideoDate.innerText = videoDate;
    ytMovieContainer.appendChild(ytVideoDate);

    const ytVideoTitle = document.createElement('span');
    ytVideoTitle.classList.add('yt-video__title');
    ytVideoTitle.innerText = videoTitle;
    ytMovieContainer.appendChild(ytVideoTitle);

    return ytMovieContainer;
}

function renderVideos(movies) {
    const videosContainer = document.querySelector('#yt-videos');
    videosContainer.innerHtml = ""
    movies.forEach((movie) => {
        videosContainer.appendChild( createVideoEl(movie.id, movie.title, movie.date))
    })
}

function changeDateFormat(videoDate) {
    var d = new Date(videoDate); 
    return d.toLocaleDateString( undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}

function initYtVideos() {
    if (movies.length === 0) {
        getMovieList();
    } else {
        renderVideos();
    }
}

initYtVideos();


  } catch(e) { console.error(e); }
})();
})();
